import { login, logout } from 'api/user';
import { clearAuth, getSimpleAuth, setSimpleAuth } from 'utils/auth';

const state = {
  userInfo: {
    accountId: null,
    username: null,
    platform: null,
    email: null,
    platformId: null,
    perms: [],
    isOpenAllAdv: null,
    isOpenAllAff: null,
    srcIds: [],
    affIds: [],
    roles: [],
    menus: [],
  },
  token: '',
};
const mutations = {
  //保存token
  COMMIT_TOKEN(state, object) {
    state.token = object.token;
  },
  COMMIT_USER_INFO(state, object) {
    state.userInfo = Object.assign({}, object);
  },
  //保存用户
  COMMIT_ROLE(state, roles) {
    state.roles = roles;
  },
};
const actions = {
  login({ commit }, userInfo) {
    const { username, password, platform } = userInfo;
    return new Promise((resolve, reject) => {
      const data = {
        username: username.trim(),
        password: password.trim(),
        platform,
      };
      login(data)
        .then((response) => {
          const { code, message, result } = response;
          if (code === 200) {
            setSimpleAuth(result);
            commit('COMMIT_TOKEN', username);
            commit('COMMIT_USER_INFO', result);
            resolve(response);
          } else {
            reject(message);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  refreshUserInfo({ commit }) {
    const cacheUserInfo = getSimpleAuth();
    if (cacheUserInfo) {
      commit('COMMIT_USER_INFO', cacheUserInfo);
    }
    // 从接口获取用户信息
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit('COMMIT_TOKEN', '');
          commit('COMMIT_ROLE', '');
          commit('app/TAGES_LIST', [], { root: true });
          commit('app/SET_BREAD_LIST', ['Dashboard'], { root: true });
          commit('financeInfo/CLEAR');
          clearAuth();
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
